module.exports = app_cads_mobileDownloadLandingPage;